export const alertDateConstants = {
  OPEN_MODAL: 'OPEN_MODAL_ALERT_DATE',
  CLOSE_MODAL: 'CLOSE_MODAL_ALERT_DATE',
};
